export enum BusinessRatingType {
  Text = 'text',
  Label = 'label',
}
